import { useSelector } from 'react-redux';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import useGruser from '@wix/da-gruser-shared/pkg/hooks/useGruser';
import { getCurrentUserHasCore } from '../../publicSession/selectors';
import { getIsGroup } from '../../User/helpers';
export const useShowCoreUpsell = (moduleId)=>{
    const hasCore = useSelector(getCurrentUserHasCore);
    const { gruserOwner } = useGruser();
    const modulePrivs = useModulePrivileges(moduleId);
    const isOwner = !!(modulePrivs === null || modulePrivs === void 0 ? void 0 : modulePrivs.edit);
    return !hasCore && isOwner && !getIsGroup(gruserOwner);
};
export default useShowCoreUpsell;

//# sourceMappingURL=useShowCoreUpsell.js.map